module.exports = __webpack_public_path__ + "img/gimmicks.70afd7c9.jpg";